import {useState} from 'react'
import {getSite} from '../services'
import {SiteModel, SelectModel} from '../model'

const useSiteListService = () => {
  const [loading, setLoading] = useState(false)
  const [siteList, setSiteList] = useState<SelectModel[]>([])
  const getSiteService = async (siteParams: SiteModel) => {
    let obj: SiteModel = {
      isCombo: true,
      ...siteParams,
    }
    return await getSite(obj, 1)
  }
  const getSiteData = async (siteParams: SiteModel) => {
    setLoading(true)
    try {
      const response = await getSiteService(siteParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching site data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getSiteFD = async (siteParams: SiteModel) => {
    setLoading(true)
    try {
      const data = await getSiteData(siteParams)
      const mapped = mapSites(data)
      return mapped
    } catch (error) {
      console.error('Error fetching site data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const mapSites = (data: any[]) => {
    return data.map((item) => ({value: item.id, label: item.nombre}))
  }

  const updateSiteList = (mappedSites: {value: string; label: string}[]) => {
    setSiteList(mappedSites)
  }

  const getSiteList = async (siteParams: SiteModel = {}) => {
    try {
      const data = await getSiteData(siteParams)
      const mappedSites = mapSites(data)
      updateSiteList(mappedSites)
    } catch (error) {
      console.error('Error fetching site data:', error)
    }
  }
  const handleClear = () => {
    setSiteList([])
  }
  return {
    loading,
    siteList,
    getSiteList,
    getSiteService,
    getSiteFD,
    handleClear,
  }
}

export default useSiteListService
